import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            searchKeyword: 'header/searchKeyword',
            userAreaId: 'user/userAreaId',
            userArea: 'user/userArea',
            userId: 'user/userId',
            userType: 'user/userType',
            currentColorScheme: 'currentColorScheme',
        }),
    },

    methods: {
        ...mapActions({
            configButton: 'header/configButton',
            setEditingButtons: 'header/setEditingButtons',
            setAddingButtons: 'header/setAddingButtons',
            setSaveUndoButtons: 'header/setSaveUndoButtons',
            popup: 'popup/popup',
            confirmation: 'confirm/confirmation',
        }),

        ...mapMutations({
            setSearchEnabled: 'header/SET_SEARCH',
            setSearchBlocked: 'header/SET_SEARCH_BLOCKED',
            showLoading: 'SHOW_LOADING',
            setLoaded: 'SET_LOADED',
            setKeyword: 'header/SET_KEYWORD',
            setNavCollapsed: 'SET_NAV_COLLAPSED',
            setUnsavedChanges: 'SET_UNSAVED_CHANGES',
            setFormValid: 'SET_FORM_VALID',
            setTableValid: 'SET_TABLE_VALID',
            setOrganizationName: 'navigation/SET_ORG_NAME',
            setContactInfo: 'navigation/SET_CONTACT_INFO',
            setColorSchemeId: 'SET_COLOR_SCHEME_ID',
            setAssignmentArea: 'SET_AA',
            setCallTypes: 'SET_CALL_TYPES',
            setExpandedWidget: 'SET_EXPANDED_WIDGET',
            setExpandedWidgetSelectBox: 'SET_WIDGET_SELECT',
            setExpandedWidgetId: 'SET_WIDGET_ID',
            removeButtons: 'header/REMOVE_BUTTONS',
            updateData: 'SET_UPDATE_DATA',
        }),
    },
};
